import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Button, { ArrowIcon } from '../components/Button';
import UrgencyBanner from '../components/UrgencyBanner';
import { candidatures, notifications } from '../lib/supabase';
import './Candidature.css';

const Icons = {
  User: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
      <circle cx="12" cy="7" r="4"></circle>
    </svg>
  ),
  Mail: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
      <polyline points="22,6 12,13 2,6"></polyline>
    </svg>
  ),
  Phone: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
    </svg>
  ),
  Calendar: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
      <line x1="16" y1="2" x2="16" y2="6"></line>
      <line x1="8" y1="2" x2="8" y2="6"></line>
      <line x1="3" y1="10" x2="21" y2="10"></line>
    </svg>
  ),
  Briefcase: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect>
      <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path>
    </svg>
  ),
  Target: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10"></circle>
      <circle cx="12" cy="12" r="6"></circle>
      <circle cx="12" cy="12" r="2"></circle>
    </svg>
  ),
  Clock: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10"></circle>
      <polyline points="12 6 12 12 16 14"></polyline>
    </svg>
  ),
  MessageCircle: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"></path>
    </svg>
  ),
  Shield: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
    </svg>
  ),
  Wallet: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 12V7H5a2 2 0 0 1 0-4h14v4"></path>
      <path d="M3 5v14a2 2 0 0 0 2 2h16v-5"></path>
      <path d="M18 12a2 2 0 0 0 0 4h4v-4h-4z"></path>
    </svg>
  ),
  Check: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="20 6 9 17 4 12"></polyline>
    </svg>
  ),
  Monitor: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect>
      <line x1="8" y1="21" x2="16" y2="21"></line>
      <line x1="12" y1="17" x2="12" y2="21"></line>
    </svg>
  ),
};

const Candidature = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Vérifier si on arrive avec un email pré-rempli depuis la Home
  const emailFromHome = location.state?.email || '';
  const acceptFromHome = location.state?.acceptTerms || false;
  const fromHome = location.state?.fromHome || false;

  const [step, setStep] = useState(fromHome && emailFromHome ? 2 : 1);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSavingEmail, setIsSavingEmail] = useState(false);
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: emailFromHome,
    phone: '',
    age: '',
    techLevel: '',
    situation: '',
    objective: '',
    availability: '',
    source: '',
    budget: '',
    acceptTerms: acceptFromHome,
  });

  // Mettre à jour formData si on reçoit un email depuis la Home
  useEffect(() => {
    if (fromHome && emailFromHome) {
      setFormData(prev => ({
        ...prev,
        email: emailFromHome,
        acceptTerms: true
      }));
      setStep(2);
    }
  }, [fromHome, emailFromHome]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  // Validation étape 1
  const canProceedStep1 = formData.email && formData.acceptTerms && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email);

  // Validation étape 2
  const canSubmit = formData.firstName && formData.lastName && formData.phone &&
                    formData.age && formData.techLevel && formData.situation &&
                    formData.objective && formData.availability && formData.source && formData.budget;

  // Sauvegarder l'email (capture du lead)
  const handleStep1Submit = async (e) => {
    e.preventDefault();
    if (!canProceedStep1) return;

    setIsSavingEmail(true);

    try {
      // Sauvegarder l'email dans Supabase
      const { data, error } = await candidatures.captureEmail(formData.email);
      if (error) {
        console.error('Erreur capture email:', error);
      } else {
        console.log('✅ Email capturé:', data);
      }
    } catch (err) {
      console.error('Erreur:', err);
    }

    setIsSavingEmail(false);
    setStep(2);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      // Sauvegarder la candidature complète dans Supabase
      const { data, error } = await candidatures.submit(formData);

      if (error) {
        console.error('Erreur soumission candidature:', error);
        alert('Une erreur est survenue. Veuillez réessayer.');
        setIsSubmitting(false);
        return;
      }

      console.log('✅ Candidature enregistrée:', data);

      // Envoyer notification email (en arrière-plan, ne bloque pas)
      notifications.sendCandidatureNotification({
        ...formData,
        candidatureId: data?.id,
      });

      // Rediriger vers la page de succès
      navigate('/inscription/succes', { state: { firstName: formData.firstName } });

    } catch (err) {
      console.error('Erreur:', err);
      alert('Une erreur est survenue. Veuillez réessayer.');
      setIsSubmitting(false);
    }
  };

  return (
    <div className="candidature-page">
      {/* Bandeau d'urgence sticky */}
      <UrgencyBanner />

      <div className="candidature-container">

        {/* Header */}
        <div className="candidature-header">
          <div className="candidature-badge">
            <span className="badge-dot"></span>
            Places limitées
          </div>
          <h1>Rejoins F12IA</h1>
          <p className="candidature-subtitle">
            {step === 1
              ? "Entre ton email pour commencer ta candidature."
              : "Plus qu'une étape ! Complète ton profil pour finaliser."
            }
          </p>
        </div>

        {/* Step Indicator */}
        <div className="steps-minimal">
          <div className={`step ${step >= 1 ? 'active' : ''} ${step > 1 ? 'done' : ''}`}>
            <span className="step-num">{step > 1 ? <Icons.Check /> : '1'}</span>
          </div>
          <div className={`step-line ${step > 1 ? 'active' : ''}`}></div>
          <div className={`step ${step >= 2 ? 'active' : ''}`}>
            <span className="step-num">2</span>
          </div>
        </div>

        {/* Step 1: Email + Consent */}
        {step === 1 && (
          <form className="candidature-form" onSubmit={handleStep1Submit}>
            <div className="form-section form-section-highlight">
              <div className="form-group">
                <label htmlFor="email">
                  <Icons.Mail />
                  Ton adresse email
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="ton@email.com"
                  required
                  autoFocus
                />
              </div>

              <div className="form-consent">
                <label className="consent-item">
                  <input
                    type="checkbox"
                    name="acceptTerms"
                    checked={formData.acceptTerms}
                    onChange={handleChange}
                    required
                  />
                  <span className="checkmark"></span>
                  <span className="consent-text">
                    J'accepte de recevoir des informations sur F12IA et d'être recontacté(e) pour ma candidature.
                  </span>
                </label>
              </div>
            </div>

            <div className="form-submit">
              <Button type="submit" size="xl" fullWidth disabled={isSavingEmail || !canProceedStep1}>
                {isSavingEmail ? (
                  <>
                    <span className="spinner"></span>
                    Un instant...
                  </>
                ) : (
                  <>
                    Continuer
                    <ArrowIcon />
                  </>
                )}
              </Button>
            </div>

            <div className="form-trust">
              <div className="trust-item">
                <Icons.Check />
                <span>Inscription gratuite</span>
              </div>
              <div className="trust-item">
                <Icons.Clock />
                <span>Places limitées</span>
              </div>
            </div>
          </form>
        )}

        {/* Step 2: Full Form */}
        {step === 2 && (
          <form className="candidature-form" onSubmit={handleSubmit}>

          {/* Infos personnelles */}
          <div className="form-section">
            <h2 className="form-section-title">Informations personnelles</h2>

            <div className="form-row">
              <div className="form-group">
                <label htmlFor="firstName">
                  <Icons.User />
                  Prénom
                </label>
                <input
                  type="text"
                  id="firstName"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleChange}
                  placeholder="Ton prénom"
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="lastName">
                  <Icons.User />
                  Nom
                </label>
                <input
                  type="text"
                  id="lastName"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleChange}
                  placeholder="Ton nom"
                  required
                />
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="phone">
                <Icons.Phone />
                Téléphone
              </label>
              <input
                type="tel"
                id="phone"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                placeholder="06 12 34 56 78"
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="age">
                <Icons.Calendar />
                Âge
              </label>
              <select
                id="age"
                name="age"
                value={formData.age}
                onChange={handleChange}
                required
              >
                <option value="">Sélectionne ta tranche d'âge</option>
                <option value="18-24">18 - 24 ans</option>
                <option value="25-34">25 - 34 ans</option>
                <option value="35-44">35 - 44 ans</option>
                <option value="45-54">45 - 54 ans</option>
                <option value="55+">55 ans et plus</option>
              </select>
            </div>

            <div className="form-group">
              <label htmlFor="techLevel">
                <Icons.Monitor />
                Quel est ton niveau en informatique ?
              </label>
              <select
                id="techLevel"
                name="techLevel"
                value={formData.techLevel}
                onChange={handleChange}
                required
              >
                <option value="">Sélectionne ton niveau</option>
                <option value="debutant">Débutant - J'utilise les bases (email, internet)</option>
                <option value="intermediaire">Intermédiaire - Je me débrouille bien</option>
                <option value="avance">Avancé - Je suis à l'aise avec la technique</option>
                <option value="expert">Expert - Je suis développeur ou tech</option>
              </select>
            </div>
          </div>

          {/* Situation */}
          <div className="form-section">
            <h2 className="form-section-title">Ta situation actuelle</h2>

            <div className="form-group">
              <label htmlFor="situation">
                <Icons.Briefcase />
                Quelle est ta situation actuelle ?
              </label>
              <select
                id="situation"
                name="situation"
                value={formData.situation}
                onChange={handleChange}
                required
              >
                <option value="">Sélectionne ta situation</option>
                <option value="salarie">Salarié(e)</option>
                <option value="freelance">Freelance / Indépendant(e)</option>
                <option value="entrepreneur">Entrepreneur(e)</option>
                <option value="recherche">En recherche d'emploi</option>
                <option value="etudiant">Étudiant(e)</option>
                <option value="reconversion">En reconversion professionnelle</option>
                <option value="autre">Autre</option>
              </select>
            </div>

            <div className="form-group">
              <label htmlFor="objective">
                <Icons.Target />
                Quel est ton objectif principal ?
              </label>
              <select
                id="objective"
                name="objective"
                value={formData.objective}
                onChange={handleChange}
                required
              >
                <option value="">Sélectionne ton objectif</option>
                <option value="complement">Revenus complémentaires (side-hustle)</option>
                <option value="reconversion">Reconversion totale</option>
                <option value="quitter-job">Quitter mon job actuel</option>
                <option value="freelance">Devenir freelance</option>
                <option value="competences">Acquérir de nouvelles compétences</option>
                <option value="autre">Autre</option>
              </select>
            </div>

            <div className="form-group">
              <label htmlFor="availability">
                <Icons.Clock />
                Combien d'heures par semaine peux-tu consacrer ?
              </label>
              <select
                id="availability"
                name="availability"
                value={formData.availability}
                onChange={handleChange}
                required
              >
                <option value="">Sélectionne ta disponibilité</option>
                <option value="5-10">5 à 10 heures</option>
                <option value="10-20">10 à 20 heures</option>
                <option value="20-30">20 à 30 heures</option>
                <option value="30+">Plus de 30 heures</option>
              </select>
            </div>

            <div className="form-group">
              <label htmlFor="source">
                <Icons.MessageCircle />
                Comment as-tu connu F12IA ?
              </label>
              <select
                id="source"
                name="source"
                value={formData.source}
                onChange={handleChange}
                required
              >
                <option value="">Sélectionne une option</option>
                <option value="instagram">Instagram</option>
                <option value="tiktok">TikTok</option>
                <option value="youtube">YouTube</option>
                <option value="facebook">Facebook</option>
                <option value="google">Recherche Google</option>
                <option value="bouche-a-oreille">Bouche à oreille</option>
                <option value="autre">Autre</option>
              </select>
            </div>

            <div className="form-group">
              <label htmlFor="budget">
                <Icons.Wallet />
                Quel budget peux-tu investir dans ta formation ?
              </label>
              <select
                id="budget"
                name="budget"
                value={formData.budget}
                onChange={handleChange}
                required
              >
                <option value="">Sélectionne ton budget</option>
                <option value="moins-1000">Moins de 1 000€</option>
                <option value="1000-2000">Entre 1 000€ et 2 000€</option>
                <option value="2000-3000">Entre 2 000€ et 3 000€</option>
                <option value="plus-3000">Plus de 3 000€</option>
                <option value="facilites">J'ai besoin de facilités de paiement</option>
              </select>
            </div>
          </div>

          {/* Email confirmation (read-only) */}
          <div className="email-confirmed">
            <Icons.Check />
            <span>Email confirmé : <strong>{formData.email}</strong></span>
            <button type="button" className="change-email-btn" onClick={() => setStep(1)}>Modifier</button>
          </div>

          {/* Submit */}
          <div className="form-submit">
            <Button type="submit" size="xl" fullWidth disabled={isSubmitting || !canSubmit}>
              {isSubmitting ? (
                <>
                  <span className="spinner"></span>
                  Envoi en cours...
                </>
              ) : (
                <>
                  Envoyer ma candidature
                  <ArrowIcon />
                </>
              )}
            </Button>
          </div>

          {/* Trust indicators */}
          <div className="form-trust">
            <div className="trust-item">
              <Icons.Shield />
              <span>Données sécurisées</span>
            </div>
            <div className="trust-item">
              <Icons.Check />
              <span>Réponse sous 48h</span>
            </div>
            <div className="trust-item">
              <Icons.Check />
              <span>Sans engagement</span>
            </div>
          </div>

        </form>
        )}

      </div>
    </div>
  );
};

export default Candidature;
